// ---------------------------------------------------------------------------
// 전 세계 실시간 교통 CCTV — /api/cctv 프록시 경유
//
// 목록만 프록시하고, 실제 프레임(jpg/mp4/m3u8)은 브라우저가 직접 로드한다
// (<img>/<video> 는 CORS 불필요). 소스는 전부 키 불필요 공공 피드이며
// 한국 ITS 만 무료 키가 있을 때 합류한다.
//
// ⚠ 타입을 api/cctv.ts 에서 import 하면 안 된다. 그 경로 요청이 dev 서버의
//    '/api/cctv' 미들웨어에 가로채여 JS 대신 JSON 이 돌아오고, 모듈 로드가
//    조용히 깨져 React 가 아예 마운트되지 않는다(에러 로그도 남지 않는다).
//    서버리스는 자기완결이어야 하므로 이 정의는 의도된 중복이다.
// ---------------------------------------------------------------------------

export interface TrafficCamera {
  id: string;
  name: string;
  lat: number;
  lon: number;
  provider: string;
  region: string;
  /** 정지 프레임 — refreshSec 주기로 갱신해 준실시간으로 본다 */
  imageUrl?: string;
  /** 짧은 mp4 클립 (TfL) */
  videoUrl?: string;
  /** HLS 실시간 스트림 (Caltrans, 한국 ITS) */
  hlsUrl?: string;
  refreshSec: number;
}

interface CctvResponse {
  cameras: TrafficCamera[];
  count: number;
  providers: Record<string, number>;
  attributions?: Record<string, string>;
}

/** provider → 라이선스 귀속 문구. 표기가 의무인 소스가 있다. */
let attributions: Record<string, string> = {
  TfL: 'Powered by TfL Open Data',
  Caltrans: 'Caltrans — cwwp2.dot.ca.gov',
  DriveBC: 'DriveBC — Open Government Licence – British Columbia',
  Ontario511: 'Ontario 511 — Open Government Licence – Ontario',
  ITS: '국가교통정보센터 (ITS)',
};

export function cameraAttribution(provider: string): string {
  return attributions[provider] ?? provider;
}

export async function fetchTrafficCameras(): Promise<TrafficCamera[]> {
  try {
    const res = await fetch('/api/cctv', { signal: AbortSignal.timeout(25_000) });
    if (!res.ok) return [];
    const json = await res.json() as CctvResponse;
    // 서버가 최신 귀속 문구를 함께 보내면 그걸 신뢰한다
    if (json.attributions) attributions = { ...attributions, ...json.attributions };
    if (json.count) console.log('[CCTV]', json.count, 'cameras', json.providers);
    return json.cameras ?? [];
  } catch (err) {
    console.warn('[CCTV] fetch failed:', err);
    return [];
  }
}
